import StudySets from "@/views/StudySets";
import CreateStudySet from "@/components/studysets/CreateStudySet";
import EditStudySet from "@/components/studysets/EditStudySet";
import DuplicateStudySet from "@/components/studysets/DuplicateStudySet";
import StudySetDetails from "@/views/StudySetDetails";

const studySetsRoutes = [
  {
    path: "/organization/:organizationId/studysets",
    name: "studysets",
    component: StudySets,
    props: true,
    meta: {
      menuItemIndex: '9',
      title:'Study Sets'
    }
  },
  {
    path: "/organization/:organizationId/curriculum/studysets/new",
    name: "studyset-new",
    component: CreateStudySet,
    props: true,
    meta: {
      menuItemIndex: '9',
      title:'Create Study Set'
    }
  },
  {
    path: "/organization/:organizationId/curriculum/studysets/:studySetId",
    name: "studyset-details",
    component: StudySetDetails,
    props: true,
    meta: {
      menuItemIndex: '9',
      title:'Study Set Details'
    }
  },
  {
    path: '/organization/:organizationId/curriculum/studysets/:studySetId/edit',
    name: 'studyset-edit',
    component: EditStudySet,
    props: true,
    meta: {
      menuItemIndex: '9',
      title:'Edit Study Set'
    }
  },
  {
    path: '/organization/:organizationId/curriculum/studysets/:studySetId/duplicate',
    name: 'studyset-duplicate',
    component: DuplicateStudySet,
    props: true,
    meta: {
      menuItemIndex: '9',
      title:'Duplicate Study Set'
    }
  }
];

export default studySetsRoutes;
